(ns app.front.view.group.admin.branding.core
  (:require [app.domain.group.model :as group-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui.section :as section]
            [app.front.ui.tabs :as ui-tabs]
            [app.front.view.group.admin.branding.email :as branding.email]
            [app.front.view.group.admin.branding.website :as branding.website]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.public-records.core :as public-records]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.i18n :as i18n]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-group-context
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/authority-groups
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::fetch-group-context.success group-id]}}))

(rf/reg-event-fx ::fetch-group-context.success
  (fn [_ [_ group-id status response]]
    {:fx (concat [[:dispatch [::entities/merge-entity-db status response]]
                  (when (-> response (get group-id) group-model/domain?)
                    [:dispatch [::public-records/fetch-authority-users group-id]])]
                 (->> (get-in response [group-id :group/languages])
                      (map (fn [lang] [:dispatch [::i18n/fetch-locale-dict-if-not-loaded lang]]))))}))

(rf/reg-event-db ::select-tab
  (fn [db [_ tab]]
    (assoc db ::selected-tab tab)))

(rf/reg-sub ::selected-tab :-> ::selected-tab)

(defn- configuration-section [tr]
  (let [group      (<sub [::gas/group])
        auth-users (<sub [::public-records/auth-users-sorted])
        group-id   (:db/id group)]
    (if (nil? group-id)
      [section/section-skeleton]
      [public-records/public-information-view tr group group-id auth-users])))

(defn view [match]
  (let [tr           (<sub [::gas/group-tr])
        group-type   (<sub [::gas/group-type])
        superdomain? (= :group.type/superdomain group-type)
        website?     (or (ff/enabled? :feature-flag.id/custom-branding)
                         (<sub [::gas/has-feature? :group.feature/custom-branding]))
        items        (cond-> []
                       (not superdomain?) (conj :group.admin.branding/configuration)
                       website?           (conj :group.admin.branding/landing-page)
                       (not superdomain?) (conj :group.admin.branding/emails))
        selected-tab (or (<sub [::selected-tab]) (first items))
        header       (when (du/at-least-two? items)
                       [ui-tabs/tabs
                        {:selected-id selected-tab
                         :aria-label  (tr [:view/group.admin.branding])
                         :on-change   #(>evt [::select-tab %])
                         :tabs        (for [item items]
                                        {:id    item
                                         :label (tr [item])})}])]
    (when (seq items)
      [acommon/admin-page-v2 {:title               (tr [:view/group.admin.public-information-and-branding])
                              :allowed-group-types #{:group.type/domain :group.type/superdomain}
                              :match               match
                              :header-content      header
                              :wait-for-group?     true}
       [acommon/section-title-wrapper {:title (tr [selected-tab])}
        (case selected-tab
          :group.admin.branding/configuration [configuration-section tr]
          :group.admin.branding/emails        [branding.email/section tr]
          :group.admin.branding/landing-page  [branding.website/section tr]
          nil)]])))

(def route
  {:name        :view/group.admin.branding
   :view        view
   :own-layout? true
   :breadcrumb  {:fallback (fn [{:keys [tr match]}]
                             [:view/group.admin.branding
                              (-> match :parameters :path)
                              (tr [:view/group.admin.public-information-and-branding])])}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [{{:keys [group-id]} :path}]
                                (>evt [::fetch-group-context group-id])
                                (>evt [::public-records/fetch-complaint-configs group-id]))
                  :stop       (fn [_]
                                (>evt [:branding/reset-branding])
                                (>evt [:branding.website/reset-ctas]))}]})
